import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import privateAxios from "../utils/axiosPrivate";
import {
  getCorporateTrustAssociateCommentURL,
  getFilterOutDeletedItemsURL,
  getUpdateCommentURL,
  getSoftDeleteCommentURL
} from "../utils/constants/apiEndPoints";

const initialState = {
  ppsrCommentLoading: false,
  notRequiredCommentLoading: false,
  notRequiredCommentAdding: false,
  notRequiredCommentDeleting: false
};

export const fetchPpsrCommentDataThunk = createAsyncThunk(
  "trustCorporateTab/fetchPpsrCommentDataThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getCorporateTrustAssociateCommentURL(payload.corporateTrustAssociateId),
        { params: payload.params }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// Thunk to fetch not required comment
export const fetchNotRequiredCommentThunk = createAsyncThunk(
  "trustCorporateTab/fetchNotRequiredCommentThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getFilterOutDeletedItemsURL(
          payload.userAccountId,
          payload.trustCorporateId
        ),
        { params: { commentType: payload.commentType } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// Thunk to add/update not required comment
export const addNotRequiredCommentThunk = createAsyncThunk(
  "trustCorporateTab/addNotRequiredCommentThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(getUpdateCommentURL, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

// Thunk to soft delete not required comment
export const deleteNotRequiredCommentThunk = createAsyncThunk(
  "trustCorporateTab/deleteNotRequiredCommentThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.patch(
        getSoftDeleteCommentURL(payload.commentId)
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

const trustCorporateTabSlice = createSlice({
  name: "trustCorporateTab",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetchPpsrCommentDataThunk
      .addCase(fetchPpsrCommentDataThunk.pending, (state) => {
        state.ppsrCommentLoading = true;
      })
      .addCase(fetchPpsrCommentDataThunk.fulfilled, (state) => {
        state.ppsrCommentLoading = false;
      })
      .addCase(fetchPpsrCommentDataThunk.rejected, (state) => {
        state.ppsrCommentLoading = false;
      })
      // fetchNotRequiredCommentThunk
      .addCase(fetchNotRequiredCommentThunk.pending, (state) => {
        state.notRequiredCommentLoading = true;
      })
      .addCase(fetchNotRequiredCommentThunk.fulfilled, (state) => {
        state.notRequiredCommentLoading = false;
      })
      .addCase(fetchNotRequiredCommentThunk.rejected, (state) => {
        state.notRequiredCommentLoading = false;
      })
      // addNotRequiredCommentThunk
      .addCase(addNotRequiredCommentThunk.pending, (state) => {
        state.notRequiredCommentAdding = true;
      })
      .addCase(addNotRequiredCommentThunk.fulfilled, (state) => {
        state.notRequiredCommentAdding = false;
      })
      .addCase(addNotRequiredCommentThunk.rejected, (state) => {
        state.notRequiredCommentAdding = false;
      })
      // deleteNotRequiredCommentThunk
      .addCase(deleteNotRequiredCommentThunk.pending, (state) => {
        state.notRequiredCommentDeleting = true;
      })
      .addCase(deleteNotRequiredCommentThunk.fulfilled, (state) => {
        state.notRequiredCommentDeleting = false;
      })
      .addCase(deleteNotRequiredCommentThunk.rejected, (state) => {
        state.notRequiredCommentDeleting = false;
      });
  }
});

export default trustCorporateTabSlice.reducer;
